<template>
  <v-dialog v-model="dialog" scrollable persistent  max-width="800px" transition="dialog-transition">
    <v-card>
      <v-card-title>
        <span class="headline">Editando dados do cliente</span>
      </v-card-title>
      <v-card-text>
        <v-col cols='12'>
          <SelectCompany
            ref="selectCompany"
            @newCompany="handleNewCompany"
            :company_key="aux_fixed_company_in_pix"
            :return_object="true"
            only_with_credentials
          ></SelectCompany>
        </v-col>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <f-btn cancel text @click="closeDialog"></f-btn>
        <f-btn save @click="emitUpdate" :disabled="!hasCompanyKey"></f-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import validations from "@/mixins/validations.js"

export default {
  name: 'ClientEditClientCompanyKey',
  mixins: [ validations ],
  props: {
    change_dialog:{
      type: Boolean,
      default: false,
    },
  },
  components:{
    FileAttachment: () => import('@/components/shared/FileAttachment.vue'),
    SelectCompany: () => import("@/_backoffice/_registrations/components/shared/SelectCompany.vue"),

  },
  data() {
    return {
      dialog: false,
      new_client:{},
      attachment_attributes: {},
      aux_fixed_company_in_pix: '',
    }
  },
  computed: {
    hasCompanyKey() {
      return !!String(this.aux_fixed_company_in_pix || '').trim()
    },
    ...mapState({
      oneClient: state => state.Client.oneClient,
    })
  },
  methods: {
    handleNewCompany(e){
      // Só atualiza quando o usuário escolhe uma empresa válida.
      // Não limpa a key atual se o select emitir null (lista ainda carregando / sem match).
      if (e?.attributes?.gateway_key) {
        this.aux_fixed_company_in_pix = e.attributes.gateway_key
      } else if (typeof e === 'string' && e.trim()) {
        this.aux_fixed_company_in_pix = e.trim()
      }
    },
    prepareClientInfo(){
      this.new_client.fixed_company_in_pix = this.aux_fixed_company_in_pix
    },
    emitUpdate(){
      const key = String(this.aux_fixed_company_in_pix || '').trim()

      if (!key) {
        this.addNotification({
          type: 'error',
          msg: 'Selecione uma empresa com gateway key para gerar PIX.',
        })
        return
      }

      this.prepareClientInfo()
      this.$emit('update', {new_client: this.new_client, model: 'info'})
    },
    closeDialog(){
      this.$emit('close')
    }
  },

  watch:{
    change_dialog(nv){
      this.dialog = nv
    },
    dialog(nv) {
      if (nv) {
        var { id, name, fantasyName, corporateName, CPF, CNPJ, category, fixed_company_in_pix, attached_file_url } = this.oneClient?.data.attributes
        this.new_client = {
          id: id,
          name: name,
          fantasyName: fantasyName,
          corporateName: corporateName,
          CPF: CPF,
          CNPJ: CNPJ,
          category: category,
          fixed_company_in_pix,
          attached_file_url: attached_file_url
        }
        this.aux_fixed_company_in_pix = fixed_company_in_pix || ''
      } else {
        this.new_client = {}
        this.attachment_attributes = {}
        this.aux_fixed_company_in_pix = ''
      }
    },
  }
}
</script>
